import { useQuery } from '@tanstack/react-query';

import { type PolicyDetails } from '~entities/policies/index';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface GetPolicyParams {
  policyId: string;
}

export const getPolicyAPI = async (params: GetPolicyParams) => {
  const response = await baseAPI.get<PolicyDetails>(
    `/policies/${params.policyId}`,
  );
  return response.data;
};

export const useGetPolicy = (params: GetPolicyParams) => {
  return useQuery({
    queryKey: [KEYS.POLICIES, params.policyId],
    queryFn: () => getPolicyAPI(params),
  });
};
